import { Box, Img, Text, useColorModeValue, Button } from "@chakra-ui/react";
import emergency from "../../assets/Group 62.svg";
import CustomModal from "../../components/CustomModal";
import EmergencyModal from "./components/EmergencyModal";
import { COLORS } from "../../constants/colors";
import { Link } from "react-router-dom";

const Emergency = () => {
  return (
    <Box buttonProps={{ ...btnProps }}>

      <EmergencyIcon />
      
    </Box>
    // <Box>
    //   <CustomModal buttonProps={{ ...btnProps }} btnTitle={<EmergencyIcon />}>
    //     <EmergencyModal />
    //     <Box mt={4} textAlign="center">
    //       <Button as={Link} to="/emergency-dashboard" colorScheme="purple" variant="outline" size="sm">
    //         Go to Full Emergency Dashboard
    //       </Button>
    //     </Box>
    //   </CustomModal>
    // </Box>
  );
};

export default Emergency;

const btnProps = { bg: "transparent", p: "1" };

const EmergencyIcon = () => {
  const emergencyBg = useColorModeValue(COLORS.primary, COLORS.white);

  return (
    <Box mb="1.5rem">
      <Link to={"/emergency-dashboard"}>
      <Img
        pos="relative"
        bottom="-4"
        left="1"
        src={emergency}
        alt="emergency"
      />

      <Text
        m="0 !important"
        fontSize="0.625rem"
        paddingBottom="5px"
        fontWeight={"bold"}
        color={emergencyBg}
        position="absolute"
      >
        Emergency
      </Text>
      </Link>
    </Box>
  );
};
